<template>
  <svg :width="width" :height="height" viewBox="0 0 15 16" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.2956 1.13327L14.432 3.23501C15.1003 3.89245 15.1091 4.96718 14.4517 5.63547L5.93277 14.295C5.67285 14.5592 5.33359 14.7311 4.96681 14.7844L2.16393 15.1917C1.39114 15.304 0.673637 14.7686 0.561341 13.9958C0.543275 13.8715 0.54186 13.7453 0.557129 13.6206L0.903151 10.7948C0.948628 10.4234 1.11555 10.0774 1.37795 9.81071L9.89511 1.15293C10.5526 0.484629 11.6273 0.47583 12.2956 1.13327ZM4.60889 12.8788L10.6515 6.73651L8.85644 4.97066L2.81524 11.1116L2.563 13.1757L4.60889 12.8788ZM12.903 4.44784L12.0098 5.35574L10.2148 3.58989L11.1079 2.68199L12.903 4.44784Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'PencilIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
